'use client'
import {
    HoverCard,
    Group,
    Button,
    UnstyledButton,
    Text,
    SimpleGrid,
    ThemeIcon,
    ActionIcon,
    Divider,
    Center,
    Box,
    Flex,
    Burger,
    Drawer,
    Collapse,
    ScrollArea,
    rem,
    useMantineTheme,
    Image
  } from '@mantine/core';
  import { useDisclosure } from '@mantine/hooks';
  import {
    IconDatabase,
    IconWorldWww,
    IconBrandOpenai,
    IconChartPie3,
    IconBuildingCommunity,
    IconCloudDataConnection,
    IconBrandYoutube,
    IconBrandFacebook,
  } from '@tabler/icons-react';
  
  import classes from './LoginNav.module.css';
  import Link from 'next/link';
  import SignUpForm from '@components/SignUpForm';
  
  const mockdata = [
    {
      icon: IconWorldWww,
      title: 'Modern Website Design',
      description: 'Make a great first impression',
    },
    {
      icon: IconCloudDataConnection,
      title: 'Easy-to-Use Backend',
      description: 'The Backbone of Your Business',
    },
    {
      icon: IconBrandOpenai,
      title: 'AI Integration',
      description: 'Save time and effort',
    },
    {
      icon: IconBuildingCommunity,
      title: 'MLS Integrations',
      description: 'List once and post automatically',
    },
    {
      icon: IconChartPie3,
      title: 'Analytics',
      description: 'Get real time business data',
    },
    {
      icon: IconDatabase,
      title: 'Automatic Backups',
      description: 'Better safe than sorry',
    },
  ];
  
  export default function LoginNav({ user }) {
    const [drawerOpened, { toggle: toggleDrawer, close: closeDrawer }] = useDisclosure(false);
    const [linksOpened, { toggle: toggleLinks }] = useDisclosure(false);
    const theme = useMantineTheme();
  
    const links = mockdata.map((item) => (
      <UnstyledButton className={classes.subLink} key={item.title}>
        <Group wrap="nowrap" align="flex-start">
          <ThemeIcon size={34} variant="default" radius="md">
            <item.icon style={{ width: rem(22), height: rem(22) }} color={theme.colors.secondary[6]} />
          </ThemeIcon>
          <div>
            <Text size="sm" fw={500}>
              {item.title}
            </Text>
            <Text size="xs" c="dimmed">
              {item.description}
            </Text>
          </div>
        </Group>
      </UnstyledButton>
    ));
  
    return (
      <Box>
        <header className={classes.header}>
          <Group justify="space-between" h="100%">
            {/* <MantineLogo size={30} /> */}
            <Flex direction='row' align='flex-end'>
              <Link href={'/'}>
                <Image
                  h={28}
                  w={160}
                  src={'/welist-logo-full.png'}
                />
              </Link>
              {/* <Image
                ml={8}
                pb={2}
                h={20}
                // w={300}
                src={'/welist-sign.svg'}
              /> */}
            </Flex>
            <Group h="100%" gap={0} visibleFrom="sm">
              {/* <a href="/" className={classes.link}>
                Home
              </a> */}
              <a href="#keyfeatures" className={classes.link}>
                Key Features
              </a>
              <a href="#backoffice" className={classes.link}>
                Back Office
              </a>
              <a href="#website" className={classes.link}>
                Website
              </a>
              <a href="#socialmarketing" className={classes.link}>
                Social Marketing
              </a>
              <a href="#pricing" className={classes.link}>
                Pricing
              </a>
              <a href="#faq" className={classes.link}>
               FAQ
              </a>
              {/* <a href="#faq" className={classes.link}>
               Contact Us
              </a> */}
              {/* <HoverCard width={600} position="bottom" radius="md" shadow="md" withinPortal>
                <HoverCard.Target>
                  <a href="/" className={classes.link}>
                    <Center inline>
                      <Box component="span" mr={5}>
                        Features
                      </Box>
                      <IconChevronDown
                        style={{ width: rem(16), height: rem(16) }}
                        color={theme.colors.blue[6]}
                      />
                    </Center>
                  </a>
                </HoverCard.Target>
  
                <HoverCard.Dropdown style={{ overflow: 'hidden' }}>
                  <Group justify="space-between" px="md">
                    <Text fw={500}>Features</Text>
                  </Group>
  
                  <Divider my="sm" />
  
                  <SimpleGrid cols={2} spacing={0}>
                    {links}
                  </SimpleGrid>
  
                  <div className={classes.dropdownFooter}>
                    <Group justify="space-between">
                      <div>
                        <Text fw={500} fz="sm">
                          Need a real estate website?
                        </Text>
                        <Text size="xs" c="dimmed">
                          Sign up know, and start your integration!
                        </Text>
                      </div>
                      <SignUpForm title="Let's get started!" size='sm' />
                    </Group>
                  </div>
                </HoverCard.Dropdown>
              </HoverCard> */}
            </Group>
            {user ? (
              <Group visibleFrom="sm">
                <Link href={'/dashboard'}>
                  <Button bg='secondary'>Go to Dashboard</Button>
                </Link>
              </Group>
            ) : (
                <Group visibleFrom="sm">
                  <Link href={'/login'}>
                    <Button bg='secondary'>Log In</Button>
                  </Link>
                </Group>
            )}
  
            <Burger opened={drawerOpened} onClick={toggleDrawer} hiddenFrom="sm" />
          </Group>
        </header>
  
        <Drawer
          opened={drawerOpened}
          onClose={closeDrawer}
          size="75%"
          padding="md"
          title="Navigation"
          hiddenFrom="sm"
          zIndex={1000000}
          position='right'
          overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}
        >
          <ScrollArea h={`calc(100vh - ${rem(80)})`} mx="-md">
            <Divider my="sm" />
              <a href="#keyfeatures" className={classes.link}>
                Key Features
              </a>
              <a href="#backoffice" className={classes.link}>
                Back Office
              </a>
              <a href="#website" className={classes.link}>
                Website
              </a>
              <a href="#socialmarketing" className={classes.link}>
                Social Marketing
              </a>
              <a href="#pricing" className={classes.link}>
                Pricing
              </a>
              <a href="#faq" className={classes.link}>
               FAQ
              </a>
            {/* <UnstyledButton className={classes.link} onClick={toggleLinks}>
              <Center inline>
                <Box component="span" mr={5}>
                  Features
                </Box>
                <IconChevronDown
                  style={{ width: rem(16), height: rem(16) }}
                  color={theme.colors.blue[6]}
                />
              </Center>
            </UnstyledButton> */}
            {/* <Collapse in={linksOpened}>{links}</Collapse> */}

            <Divider my="sm" />
            <Flex direction='row' justify='center' gap={12}>
              <a href='https://www.facebook.com/WeListAI' target='_blank'>
                <ActionIcon size="lg" color="gray" variant="subtle">
                  <IconBrandFacebook style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
                </ActionIcon>
              </a>
              <a href='https://www.youtube.com/@WeListAI' target='_blank'>
                <ActionIcon size="lg" color="gray" variant="subtle">
                  <IconBrandYoutube style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
                </ActionIcon>
              </a>
            </Flex>
          </ScrollArea>
        </Drawer>
      </Box>
    );
  }